import { useTranslation } from "react-i18next";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui";

export interface MessengerChatRefreshButtonProps {
  onRefresh: () => void;
  isRefreshing?: boolean;
}

export function MessengerChatRefreshButton({
  onRefresh,
  isRefreshing = false,
}: MessengerChatRefreshButtonProps) {
  const { t } = useTranslation("common");

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      isLoading={isRefreshing}
      leftIcon={<RefreshCw className="h-4 w-4" />}
      onClick={onRefresh}
      aria-label={t("refresh")}
      className="shrink-0"
    />
  );
}
